import Popup from '~/components/Popup';

export default function Help() {
  return (
    <Popup title="Disclaimer" pos="bottomRight">
      <h2>Disclaimer</h2>
      <p>+x+calc makes no claims whatsoever to being correct.</p>
    </Popup>
  );
}
